export default (params) => ({
  trigger: {
    name: 'configurator.add_bundle_to_cart',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      attached_item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
      sub_feature: {
        enum: [
          'configurator',
          'configurator_overlay',
        ],
      },
    },
    event: {
      name: 'add_bundle_to_cart',
    },
  },
});
